<div class="icon-container">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 7L9.49026 17.8171C10.6271 19.7118 13.3729 19.7118 14.5097 17.8171L21 7" stroke="white" stroke-width="2"
      stroke-linecap="round" />
  </svg>
</div>
